<template>
    <search-group title="供应商查询" @search="findData" @clear="clearValue" :span="8" > 
        <Row class="mb16">
            <Col span="4" class="zr-label">供应类目</Col>
            <Col span="15">
                 <Select v-model="categoryValue" :label-in-value="true" @on-change="getLabel">
                    <Option value="">请选择</Option>
                    <Option value="100" v-for="item in categoryList" :value="item.value" :key="item.value">{{item.text}}</Option>
                </Select>
            </Col>
        </Row>
    </search-group>
</template>
 
<script type="text/ecmascript-6">

import SearchGroup from 'components/SearchGroup/index';
export default {
    components: {
       SearchGroup
    },
    props:{ 
        categoryList:{
            type:Array,
            default:[]
        }     
    },
    data () {
        return {
            categoryValue:"",
            searchData: {        
              categoryName:"",
              page: 1,
              limit: 10
            }
        }
    },
    methods: {
        findData() {
            this.$emit('postParams', this.searchData);
        },
        clearValue() {
            this.categoryValue = '';
            this.searchData.categoryName =''
        },
        getLabel(obj){
            if(obj.value===''){
              this.searchData.categoryName=''
            }else{
              this.searchData.categoryName = obj.label
            }
           
        }
    }
}
</script>